import AxiosInstance from 'config/apiServiceApiGateway'
import { PaginationInterface } from 'features/Enterprise/SKP/@types/sourcingTypes'
import { TermsAndConditionsDataInterface } from 'features/Enterprise/SKP/redux/tnc'

import { SKPDataQueryInterface } from './sourcing'

interface GetTnCListLegacyResponseInterface {
  data: TermsAndConditionsDataInterface[]
  query: SKPDataQueryInterface
}

interface GetTnCListEchoResponseInterface {
  data: {
    result: TermsAndConditionsDataInterface[]
    pagination: PaginationInterface
  }
}

type GetTnCListResponseInterface =
  | GetTnCListLegacyResponseInterface
  | GetTnCListEchoResponseInterface

interface PostTnCParamsInterface {
  promotion_type: string
  tnc_description: string
  tnc_status: string
  tnc_title: string
}

interface PutEditAddTnCResponseInterface {
  code: number
  message: string
}

export const fetchTnCList = (query: string) =>
  AxiosInstance.Get<GetTnCListResponseInterface, true>({
    url: `/skp/internal/v1/terms-and-conditions?${query}`,
  })

export const putEditTnC = (params: PostTnCParamsInterface, id: number) =>
  AxiosInstance.Put<PutEditAddTnCResponseInterface, true>({
    url: `/skp/internal/v1/terms-and-conditions/${id}`,
    data: params,
  })

export const deleteTnC = (id: number) =>
  AxiosInstance.Delete({ url: `/skp/internal/v1/terms-and-conditions/${id}` })

export const postAddTnC = (params: PostTnCParamsInterface) =>
  AxiosInstance.Post<PutEditAddTnCResponseInterface, true>({
    url: '/skp/internal/v1/terms-and-conditions',
    data: params,
  })
